import type { SidebarNavItem } from "@app/core";
import { storeToRefs } from "pinia";
import { shallowRef, watchEffect } from "vue";

import { getMenuItems } from "../modules";
import type { MenuItem } from "../types/types";

import { useAuthStore } from "@/features/auth/store/authStore";
import { usePartnershipStore } from "@/features/partnership/store/partnershipStore";

const toNavItem = (item: MenuItem): SidebarNavItem => {
  return {
    id: item.id,
    label: item.label,
    icon: item.icon,
    badge: item.badge,
    disabled: item.disabled,
    to: item.to,
    order: item.order,
    children: item.children?.map(toNavItem),
  };
};

export const useMenu = () => {
  const authStore = useAuthStore();
  const partnershipStore = usePartnershipStore();

  const { partnership } = storeToRefs(partnershipStore);

  const menuItems = shallowRef<SidebarNavItem[]>([]);
  watchEffect(() => {
    menuItems.value = getMenuItems(authStore, partnership.value).map(toNavItem);
  });

  return { menuItems };
};
